import PropTypes from 'prop-types';

import BlockReasonBadge from '#customColumnsFeature/components/BlockReasonBadge/BlockReasonBadge';
import Table from '#globalComponents/Table/Table';

const COLUMNS = [
	{
		key: 'emailRecipient',
		label: 'Empfänger E-Mail',
		render: (r) => <span className="text-text">{r.emailRecipient || '-'}</span>,
	},
	{
		key: 'companyName',
		label: 'Firma',
		render: (r) => <span className="text-bgBase-800">{r.companyName || '-'}</span>,
	},
	{
		key: 'status',
		label: 'Status',
		render: (r) => <BlockReasonBadge reason={r.reason} missingKeys={r.missingKeys} />,
	},
];

const BlockedRecipientsTable = ({ recipients, isLoading = false }) => (
	<Table
		rows={recipients}
		columns={COLUMNS}
		rowId={(r) => r.crmContactId || r.crmCompanyId || r.emailRecipient}
		isLoading={isLoading}
		emptyLabel="Empfänger, die auf der Blacklist stehen oder denen ein Spaltenwert fehlt, erscheinen hier."
	/>
);

BlockedRecipientsTable.propTypes = {
	recipients: PropTypes.arrayOf(
		PropTypes.shape({
			emailRecipient: PropTypes.string,
			companyName: PropTypes.string,
			crmContactId: PropTypes.string,
			crmCompanyId: PropTypes.string,
		}),
	).isRequired,
	isLoading: PropTypes.bool,
};

export default BlockedRecipientsTable;
